import styled, { css } from "styled-components";

import { TextWrapper as TextWrapperDefault } from "src/organization/common/components/activities/Activity/Activity.styles";

const customBackupSchedulesStyles = css`
  grid-template-columns: max-content 265px 79fr 133fr;

  @media (max-width: 1300px) {
    grid-template-columns: max-content 265px 55fr 133fr;
  }

  @media (max-width: 1060px) {
    grid-template-columns: max-content 265px 30fr 133fr;
  }
`;

const backupStyles = css`
  grid-template-columns: max-content max-content 1fr;
`;

export const Content = styled.div<{ isCustomBackupSchedulesEnabled: boolean }>`
  display: grid;
  align-items: center;

  ${({ isCustomBackupSchedulesEnabled }) =>
    isCustomBackupSchedulesEnabled ? customBackupSchedulesStyles : backupStyles}
`;

export const TextWrapper = styled(TextWrapperDefault)`
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  align-items: center;
`;

export const EndContent = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;
